import React, { useState } from "react";

import classes from "./Search.module.css";

const Search = props => {
  const [isSearching, setIsSearching] = useState(false);

  const startSearching = () => setIsSearching(true);
  const stopSearching = () => setIsSearching(false);

  return (
    <div className={classes.Search}>
      <input
        type="text"
        name="Search"
        placeholder="Film, tür, oyuncu..."
        onChange={props.search}
        className={isSearching ? classes.Active : undefined}
      />
      <i
        onClick={startSearching}
        className={`fas fa-search ${classes.searchIcon} 
        ${isSearching ? classes.Hide : undefined}`}
      ></i>
      <i
        onClick={stopSearching}
        className={`fas fa-times ${classes.Close} ${
          isSearching ? classes.Show : undefined
        }`}
      ></i>
    </div>
  );
};

export default Search;
